"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Possible levels of a question.
 */
var QuestionLevel;
(function (QuestionLevel) {
    QuestionLevel["easy"] = "easy";
    QuestionLevel["normal"] = "normal";
    QuestionLevel["hard"] = "hard";
})(QuestionLevel = exports.QuestionLevel || (exports.QuestionLevel = {}));
//# sourceMappingURL=serialized-question.js.map